module.exports = {
  siteTitle: 'Vishal Singh',
  siteDescription:
    'Vishal Singh is an Software Developer, based in India, who loves learning new things and helping tech beginners.',
  siteKeywords:
    'Vishal Singh, Vishal, Singh, software engineer, web developer, javascript, python, java, svvv, Gwalior, India, software developer, open source, portfolio',
  siteUrl: 'https://vishal-git9.github.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-4566659-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qiwpbx9Lk',
  name: 'Vishal Singh',
  location: 'Gwalior, India',
  email: 'vishalsinghrajawat990@gmail.com',
  github: 'https://github.com/vishal-git9',
  twitterHandle: '@',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/vishal-git9',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/vishal-rajawat-768577196/',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/__vishalrajawat__',
    },
    {
      name: 'Medium',
      url: 'https://medium.com/@vishalsinghrajawat990',
    },
     {
      name: 'Leetcode',
      url: 'https://leetcode.com/u/vishalsinghrajawat990/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
